"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _PhoneField = _interopRequireDefault(require("./PhoneField"));

var _otpVerification = _interopRequireDefault(require("./otp-verification"));

var _Icons = require("./Icons.js");

var _Loader = require("./Loader");

var _signUpModule = _interopRequireDefault(require("../styles/sign-up.module.css"));

var _baseModule = _interopRequireDefault(require("../styles/base.module.css"));

var _formFiledModule = _interopRequireDefault(require("../styles/form-filed.module.css"));

var _loginModule = _interopRequireDefault(require("../styles/login.module.css"));

var _constant = require("./constant");

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _typeof(obj) {
  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    _typeof = function _typeof(obj) {
      return typeof obj;
    };
  } else {
    _typeof = function _typeof(obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
  }

  return _typeof(obj);
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}

function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  return Constructor;
}

function _possibleConstructorReturn(self, call) {
  if (call && (_typeof(call) === "object" || typeof call === "function")) {
    return call;
  }

  return _assertThisInitialized(self);
}

function _getPrototypeOf(o) {
  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
    return o.__proto__ || Object.getPrototypeOf(o);
  };
  return _getPrototypeOf(o);
}

function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return self;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      writable: true,
      configurable: true
    }
  });
  if (superClass) _setPrototypeOf(subClass, superClass);
}

function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };

  return _setPrototypeOf(o, p);
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

var OTPLogin =
/*#__PURE__*/
function (_React$Component) {
  _inherits(OTPLogin, _React$Component);

  function OTPLogin(props) {
    var _this;

    _classCallCheck(this, OTPLogin);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(OTPLogin).call(this, props));

    _defineProperty(_assertThisInitialized(_this), "sendOTP", function (e) {
      e.preventDefault();
      var phone = e.target.elements['number'].value;
      var countryCode = _this.state.countryCode;

      if (e.target.elements['number_country_code'].value !== '') {
        countryCode = e.target.elements['number_country_code'].value;
      }

      _this.setState({
        phone: phone,
        countryCode: countryCode
      });

      var formData = new FormData(e.target);
      formData.append('countryCode', countryCode);

      _this.setState({
        loading: true,
        error: false
      });

      fetch("".concat(_constant.API_ROOT, "sendOTPToRegistered.php"), {
        credentials: 'same-origin',
        method: 'POST',
        body: formData
      }).then(_constant.checkStatus).then(_constant.parseJSON).then(function (data) {
        if (data.status !== false) {
          _this.setState({
            sent: true,
            uid: data.registered,
            loading: false
          });
        } else {
          if (data.errorCode === 1) _this.setState({
            error: true,
            loading: false,
            message: 'This phone number is not registered.'
          });else _this.setState({
            error: true,
            loading: false,
            message: 'OTP verification code could not be sent. Please try again later.'
          });
        }
      }).catch(function (err) {
        return console.log(err);
      });
    });

    _this.state = {
      phone: '',
      countryCode: '',
      uid: null,
      loading: false,
      error: false,
      sent: false,
      message: ''
    };
    return _this;
  }

  _createClass(OTPLogin, [{
    key: "render",
    value: function render() {
      var _this2 = this;

      var _this$props = this.props,
          switchMode = _this$props.switchMode,
          onSuccess = _this$props.onSuccess;
      var _this$state = this.state,
          loading = _this$state.loading,
          error = _this$state.error,
          sent = _this$state.sent,
          phone = _this$state.phone,
          countryCode = _this$state.countryCode,
          uid = _this$state.uid,
          message = _this$state.message;
      if (sent) return _react.default.createElement(_otpVerification.default, {
        phone: phone,
        countryCode: countryCode,
        uid: uid,
        back: function back() {
          return _this2.setState({
            sent: false
          });
        },
        onSuccess: onSuccess
      });
      return _react.default.createElement("form", {
        className: _baseModule.default.container,
        onSubmit: this.sendOTP
      }, error ? _react.default.createElement("span", {
        className: _loginModule.default.errorBlock
      }, _react.default.createElement(_Icons.CrossInsideCircle, {
        width: "1rem"
      }), _react.default.createElement("span", null, message)) : '', _react.default.createElement("div", {
        className: _signUpModule.default.phoneFieldParent
      }, _react.default.createElement(_PhoneField.default, {
        defaultValue: this.state.phone,
        countryCode: this.state.countryCode,
        placeholder: "Contact number",
        className: "".concat(_formFiledModule.default.input, " ").concat(_baseModule.default.rightPhoneIcon),
        required: true,
        name: "number"
      }), _react.default.createElement("p", null, _react.default.createElement(_Icons.GreenCircularTick, {
        width: "0.875rem",
        color: "#484848"
      }), _react.default.createElement("span", null, "Verification code will be sent to the provided contact."))), _react.default.createElement("div", {
        className: _formFiledModule.default.buttonParent
      }, _react.default.createElement("button", {
        type: "submit",
        className: "".concat(_formFiledModule.default.button, " ").concat(_formFiledModule.default.primary, " ").concat(_formFiledModule.default.block),
        disabled: loading
      }, loading ? _react.default.createElement(_Loader.ButtonLoader, null) : 'Continue'), _react.default.createElement("div", {
        className: "".concat(_formFiledModule.default.button, " ").concat(_formFiledModule.default.block),
        onClick: function onClick() {
          switchMode(_constant.EMAIL_LOGIN_MODE);
        }
      }, "Log in with E-mail")));
    }
  }]);

  return OTPLogin;
}(_react.default.Component);

var _default = OTPLogin;
exports.default = _default;